export default __webpack_public_path__ + "static/media/BusModel.428b08fb.svg";